<template>
	<div>
		<MiniAppWizard
			:tabItems="tabItems"
			:state="state"
			:finalResult="finalResult"
			v-on:updateState="updateState"
			@updateState="updateState"
			@on-mini-app-finished="$emit('on-mini-app-finished')"
			@on-mini-app-cancel="$emit('on-mini-app-cancel')"
		/>
		<!-- state: {{ state }} -->
	</div>
</template>

<script>
import MiniAppWizard from './MiniAppWizard';
import TableRowSelectorStep from './steps/TableRowSelectorStep';
import ColumnsMappingStep from './steps/ColumnsMappingStep';
import FinishMappingStep from './steps/FinishMappingStep';

import ColumnMapperService from './ColumnMapperService';

export default {
	name: 'TableMapperMiniApp',
	components: {
		MiniAppWizard,
	},
	props: {
		rows: { type: Array },
		headers: { type: Array },
		columnOptions: { type: Array },
		finalResult: { type: Array },
		isHeadersMappingMode: { type: Boolean },
	},
	computed: {
		tabItems() {
			const { state, rows, headers, columnOptions, finalResult, isHeadersMappingMode } = this;
			const filteredRows = ColumnMapperService.getFilteredRows(rows, state.originalNewHeaderRow);
			return [
				{
					tab: 'TableRowSelectorStep_tab',
					title: 'TableRowSelectorStep',
					component: TableRowSelectorStep,
					props: { rows, headers },
					validator: () => null,
				},
				{
					tab: 'ColumnsMappingStep_tab',
					title: 'ColumnsMappingStep',
					component: ColumnsMappingStep,
					props: { rows: filteredRows, columnOptions },
					validator: (state, props) => {
						let isValid = true;
						props.columnOptions.forEach((opt) => {
							isValid = isValid && (!opt.required || Object.keys(state.columnsMapping).includes(opt.value));
						});
						return isValid ? null : 'Please select all required columns';
					},
				},
				{
					tab: 'FinishMappingStep_tab',
					title: 'FinishMappingStep',
					component: FinishMappingStep,
					props: { finalResult, isHeadersMappingMode },
					validator: () => null,
				},
			];
		},
	},
	methods: {
		updateState(newState) {
			this.state = { ...this.state, ...JSON.parse(JSON.stringify(newState)) };
			const { columnsMapping, originalNewHeaderRow } = this.state;
			const filteredRows = ColumnMapperService.getFilteredRows(this.rows, originalNewHeaderRow);

			if (columnsMapping) {
				this.$emit('onResultTableChanged', ColumnMapperService.mapTable(filteredRows, columnsMapping, this.isHeadersMappingMode));
			}
		},
	},
	data() {
		const state = {
			columnsMapping: {},
		};

		return {
			state,
		};
	},
};
</script>
<style scoped lang="scss"></style>
